import { useEffect,useRef } from 'react';
import { AutoSizer,List, WindowScroller } from 'react-virtualized';

import useIsFirstRender from "@/hooks/useIsFirstRender";
import useScreenSize from "@/hooks/useScreenSize";
import ArtlistCard from "@/shared-components/cards/components/ArtlistCard";
import InfiniteScroll from '@/shared-components/lists/components/InfiniteScroll';

import './styles/VirtualList.css';

export default function VirtualList({ items, visibleItems, onLoadMore }) {
  const listRef = useRef();
  const screenSize = useScreenSize();
  const listSizes = useRef(computeListSizes());
  const isFirstRender = useIsFirstRender();

  function computeListSizes() {
    const widthOfContainer =
      screenSize.width <= 700
        ? Math.min(550, screenSize.width - 40)
        : screenSize.width <= 1004
          ? screenSize.width - 278
          : Math.min(980, screenSize.width - 300);
    const spacer = screenSize.width <= 600 ? 10 : 15; // column gap
    const rowGap = screenSize.width <= 600 ? 12 : screenSize.width <= 1004 ? 16 : 18; // vertical gap between rows
    const columnsPerRow = screenSize.width <= 1004 ? 2 : 3; // 2 cols up to 1004px
    const columnWidth = (widthOfContainer - (columnsPerRow - 1) * spacer) / columnsPerRow;
    const rowHeight = columnWidth + rowGap;
    return { columnWidth, columnsPerRow, rowHeight };
  }

  useEffect(()=>{
    if(!isFirstRender) {
      listSizes.current = computeListSizes();
      listRef.current.recomputeRowHeights();
    } 
  }, [screenSize]);

  return (
    <>
      <InfiniteScroll 
        onLoadMore={onLoadMore} 
        shouldLoadMore={items.data.length < items.totalDocs} 
        offsetElements={3} 
        listLength={visibleItems.length} 
      >
        {({ infiniteScrollAssigner }) => (
          <WindowScroller>
            {({ height, isScrolling, onChildScroll, scrollTop }) => (
              <AutoSizer disableHeight>
                {({ width }) => {
                  return (
                    <List
                      autoHeight
                      width={width === 0 ? 0.1 : width}
                      height={height}
                      isScrolling={isScrolling}
                      onScroll={onChildScroll}
                      scrollTop={scrollTop}
                      ref={listRef}
                      overscanRowCount={3}
                      rowCount={Math.ceil(visibleItems.length / listSizes.current.columnsPerRow)}
                      rowHeight={listSizes.current.rowHeight}
                      estimatedRowSize={500}
                      rowRenderer={({ index, key, style }) => {
                        let columns = [];
                        const fromIndex = index * listSizes.current.columnsPerRow;
                        const toIndex = Math.min(fromIndex + listSizes.current.columnsPerRow, visibleItems.length);
        
                        for(let i=fromIndex; i<toIndex; i++) {
                          columns.push(
                            <ArtlistCard 
                              key={i} 
                              data={visibleItems[i]} 
                              style={{ width: `${listSizes.current.columnWidth}px` }}
                              infiniteScrollObserver={infiniteScrollAssigner(i)}
                            />
                          );
                        }
        
                        return (
                          <div className="activity-liked-artlists-virtual-row" key={key} style={style}>
                            {columns}
                          </div>
                        );
                      }}
                    />
                  );
                }}
              </AutoSizer>
            )}
          </WindowScroller>
        )}
      </InfiniteScroll>
    </>
  );
}
